import React from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import FullScreenLoader from '../../../../../../components/global/FullScreenLoader';
import {
  ALBUM_SLIDESHOW_MODE,
  ALBUM_SLIDESHOW_STATUS,
} from '../../../../../../constants/albums';
import AlbumSlideshow from '../../AlbumSlideshow';
import VideoSlideshow from '../../VideoSlideshow';
import { AlbumSlideshowForModeCheck } from '../../../../../../graphql/queries/albums';
import { useContributorPermission } from '../../../../services/contributors';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumId: PropTypes.string,
    }),
  }),
};

const SlideshowView = ({ match }) => {
  const { albumId } = match.params;
  const { data: { loading, album } = {} } = useQuery(
    AlbumSlideshowForModeCheck,
    {
      variables: {
        id: albumId,
      },
      skip: !albumId,
    },
  );

  const { isContributor, isOwner } = useContributorPermission({
    entityId: albumId,
  });

  // Scenario A: Album is not loaded or not found
  if (loading || !album || !album?.slideshow) {
    return <FullScreenLoader />;
  }

  // Scenario B: User is trying to access a public slideshow that's not been published
  if (
    isOwner &&
    !isContributor &&
    album?.slideshow?.mode === ALBUM_SLIDESHOW_STATUS.DRAFT
  ) {
    return <FullScreenLoader />;
  }

  if (album.slideshow?.mode === ALBUM_SLIDESHOW_MODE.ALL_VIDEOS) {
    return <VideoSlideshow />;
  }

  return <AlbumSlideshow />;
};

SlideshowView.propTypes = propTypes;

export default compose(withRouter)(SlideshowView);
